import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * An old address for setup's conversation. Setup is the studio at
 * `/onboarding` now, so a bookmark or a tab still open on this one lands there.
 */
export const Route = createFileRoute('/onboarding/talk')({
  beforeLoad: () => {
    throw redirect({ to: '/onboarding', replace: true });
  },
});
